import React from "react"
import { MarcaCaldaiaSelector } from "../../marcheCaldaie/components/marcaCaldaiaSelector"
import { CaldaiaSelector } from "./caldaiaSelector"
import { CaldaiaDto } from "../../generated"
import { CaldaieStore } from "../caldaieStore"
import { CaldaiaToolbarButton } from "./CaldaiaDialog"

interface Props {
    value: number | null,
    onChange: (type: CaldaiaDto | null) => void
    error?: string;
}

export const SmartCaldaiaSelector = (props: Props) => {
    const caldaia = CaldaieStore.use(props.value && props.value || null);
    const [marca, setMarca] = React.useState(caldaia?.marcaCaldaia ?? null);
    const marcaCaldaia = marca ?? caldaia?.marcaCaldaia ?? "";

    const onChangeMarca = (m: string | null) => {
        setMarca(m);
        props.onChange(null);
    }

    return <div className="card">
        <div className="card-header d-flex align-items-center justify-content-between">
            <div className="text-uppercase fw-bold">
                Selezione Apparecchio
            </div>
        </div>
        <div className="card-body pt-0 pb-0">
            <MarcaCaldaiaSelector
                onChange={onChangeMarca}
                value={marcaCaldaia}
                label="Produttore"
                error={props.error}
            />
            {marcaCaldaia && <CaldaiaSelector
                marca={marcaCaldaia}
                value={caldaia?.idCaldaia ?? null}
                onChange={props.onChange}
                label="Modello"
                error={props.error}
            />}
            {
                caldaia && <div className="d-flex flex-wrap justify-content-center" style={{ marginTop: -10, marginBottom: 5 }}>
                    <div className="me-3">Pot. Focolare: <span className="text-theme">{caldaia.potenzaFocolare && caldaia.potenzaFocolare > 0 ? caldaia.potenzaFocolare : "N.C."} KW</span> </div>
                    <div className="me-3">Pot. Nominale: <span className="text-theme">{caldaia.potenzaUtile && caldaia.potenzaUtile > 0 ? caldaia.potenzaUtile : "N.C."} KW</span> </div>
                </div>
            }
        </div>
        <div className="card-footer">
            <CaldaiaToolbarButton
                idCaldaia={caldaia?.idCaldaia}
                onSelect={props.onChange}
            />
        </div>
    </div>
}